import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS, Pin } from 'common/constants';
import { OTHER_PROPS } from 'common/constants/component-props';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const sliderPagination = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.SLIDER_PAGINATION> =>
	createModel({
		type: COMPONENT_TYPE.SLIDER_PAGINATION,
		editorProps: {
			draggable: false,
		},
		componentProps: {
			styles: {},
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[OTHER_PROPS.pin.pinType]: Pin.b,
					},
				},
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.SLIDER_PAGINATION>;
